import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Recital } from '../model/recital';

export const publishRecitalAPI = async (recitalId: string) => {
  const response = await baseAPI.post<Recital>(
    `/recitals/${recitalId}/publish`,
  );
  return response.data;
};

export const usePublishRecitalMutation = () => {
  return useMutation({
    mutationFn: async (recitalId: string) => {
      return await publishRecitalAPI(recitalId);
    },
    onSuccess: (_, recitalId) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, recitalId],
      });
    },
  });
};
